import GaugeChart from "../../../components/Charts/GaugeChart"
import { ChartContainerLoader } from "../../../components/Generic/Charts"
import { useTranslation } from "react-i18next"

const Avance:React.FC<{ porcentajeAvance?:number }> = ({ porcentajeAvance }) => {
    const {t} = useTranslation('translation',{keyPrefix: 'avance'})


    if(!porcentajeAvance) {
        return (
            <ChartContainerLoader colSize="12" />
        )
    }

    return (
        <GaugeChart
          chartName={t("progreso")}
          data={porcentajeAvance}
        />
    )
}

export default Avance;